module.exports = __webpack_public_path__ + "static/images/user-missed-pickup.759d6f97eee2d78979429a1d68b0f330.svg";